<div *ngIf="doneLoading">
  <section>
    <h1 class="header-1">{{ 'register.title' | translate }} {{ eventName}} </h1>
    <p>{{ eventStart | date : 'EEEE d LLLL H:MM' : '' : dateFormat }} - {{ eventEnd | date : 'EEEE d LLLL H:MM' : '' : dateFormat}}</p>
  </section>
  <section class="form">
    <div *ngIf="formData != null">
      <div class="row" *ngIf="formData.steps[0].visible" >
        <div class="col-1-4">
        </div>
        <div class="col" ng-reflect-ng-switch="text">
          <input type="radio" title="I register myself" id="register-self" name="register" value="self" [(ngModel)]="register" [checked]="register === 'self'" (ngModelChange)="onRegistrarChange()" />
          <label for="register-self" class="label">{{ 'register.register-self'|translate }}</label>
          <input type="radio" title="I register someone else" id="register-someone-else" name="register" value="other" [(ngModel)]="register" [checked]="register === 'other'" (ngModelChange)="onRegistrarChange()"/>
          <label for="register-someone-else" class="label">{{ 'register.register-other'|translate }}</label>
        </div>
      </div>

      <div *ngFor="let step of formData.steps">
        <div [hidden]="!step.visible">
          <form (ngSubmit)="onSubmit()" [formGroup]="step.form" #registerForm="ngForm" class="section">
            <div *ngFor="let section of step.sections">
              <h3>{{ section.title }}</h3>
              <p *ngIf="section.description != null" [innerHTML]="section.description"></p>
              <div class="elem" *ngFor="let element of section.elements">
                <div [ngSwitch]="getElementType(element)">
                  <app-multiselect-control *ngSwitchCase="'multiselect'" [question]="element" [formGroup]="step.form" [form]="registerForm"></app-multiselect-control>
                  <app-kvk-search *ngSwitchCase="'kvkSearch'" (kvkSearch)="onKvkSearch($event)" (caribbean)="onCaribbeanChange($event)" [question]="element" [formGroup]="step.form" [form]="registerForm"></app-kvk-search>
                  <app-form-question *ngSwitchDefault [question]="element" [formGroup]="step.form" [form]="registerForm" (copyAddress)="onCopyAddress($event)"></app-form-question>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-1-4"></div>
              <div class="col">
                <button type="button" (click)="onPreviousSection()" *ngIf="canPreviousSection()">{{ 'register.previous' |
                  translate }}</button>
                <button type="submit" *ngIf="canNextSection()">{{ 'register.next' | translate }}</button>
                <button type="submit" [disabled]="(loader.IsLoading | async)" *ngIf="isLastPage()">{{
                  'register.submit' | translate }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div *ngIf="formData == null && formNotFound === false">
      <span>Loading...</span>
    </div>

    <div *ngIf="formNotFound === true">
      <strong>The requested form was not found.</strong>
    </div>
  </section>
</div>
